import { Modal, Stack, Box, Text, Button } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

type CardPermissionErrorModalProps = {
  opened: boolean;
  /** Đóng popup (vd quay lại màn danh sách / ở lại list). */
  onClose: () => void;
  /** Nội dung lỗi — thường là resultDesc từ BE. Fallback về text mặc định. */
  message?: string;
  /** Điều hướng sang màn Quản lý yêu cầu. */
  onManageRequest: () => void;
};

/**
 * Popup thông báo không có quyền thao tác thẻ — dùng chung cho màn danh sách
 * và màn chi tiết khi API trả resultCode khác SUCCESS (vd CC-REQ-003).
 */
const CardPermissionErrorModal = ({
  opened,
  onClose,
  message,
  onManageRequest,
}: CardPermissionErrorModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      withCloseButton={false}
      size={368}
      radius={8}
      padding={24}
      overlayProps={{ opacity: 0.4, blur: 2 }}
      styles={{ body: { padding: 0 } }}
    >
      <Stack align="center" spacing={16} p={24}>
        {/* Icon: khối vuông bo tròn nền hồng nhạt + tròn đỏ chữ X trắng */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: "#FEE2E2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "#DC2626",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconX size={26} color="#FFFFFF" stroke={3} />
          </Box>
        </Box>

        <Text fw={700} fz={16} color="#15315B" ta="center">
          {t("NOTIFICATION")}
        </Text>

        <Text fz={14} color="#5E656B" ta="center">
          {message || t("NO_PERMISSION_TO_OPERATE_CARD")}
        </Text>

        <Stack spacing={12} sx={{ width: "100%" }}>
          <Button
            fullWidth
            radius={4}
            h={40}
            onClick={onClose}
            styles={{
              root: {
                background: "#2A81D0",
                color: "#FFFFFF",
                fontWeight: 600,
                height: 40,
                "&:hover": { background: "#1F6AB5" },
              },
            }}
          >
            {t("CLOSE")}
          </Button>
          <Button
            fullWidth
            variant="outline"
            radius={4}
            h={40}
            onClick={onManageRequest}
            styles={{
              root: {
                borderColor: "#2A81D0",
                color: "#2A81D0",
                fontWeight: 600,
                height: 40,
              },
            }}
          >
            {t("MANAGE_REQUEST")}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default CardPermissionErrorModal;
